import Banner from './Banner/Banner';
import IfConfirm from './IfConfirm/IfConfirm';

export { Banner };
export { IfConfirm };
